export var CompanyPlanTypes;
(function (CompanyPlanTypes) {
    CompanyPlanTypes["FreeTrial"] = "free trial";
    CompanyPlanTypes["Legacy"] = "legacy";
    CompanyPlanTypes["Standard"] = "standard";
    CompanyPlanTypes["Pro"] = "pro";
    CompanyPlanTypes["Enterprise"] = "enterprise";
})(CompanyPlanTypes || (CompanyPlanTypes = {}));
